import React, { useEffect, useRef, useState } from 'react';
import CopyableField from './CopyableField';
import NoteDisplay from './NoteDisplay';
import copyToClipboard from '../utils/copyToClipboard';

const PasswordCard = ({ password, onEdit, onDelete }) => {
  const [visible, setVisible] = useState(false);
  const [urlCopied, setUrlCopied] = useState(false);
  const urlCopiedTimeoutRef = useRef(null);

  const hasUrl = Boolean(password.url?.trim());

  useEffect(() => {
    return () => {
      if (urlCopiedTimeoutRef.current) {
        clearTimeout(urlCopiedTimeoutRef.current);
      }
    };
  }, []);

  const handleCopyUrl = () => {
    if (!hasUrl) return;

    copyToClipboard(password.url);

    setUrlCopied(true);
    if (urlCopiedTimeoutRef.current) {
      clearTimeout(urlCopiedTimeoutRef.current);
    }
    urlCopiedTimeoutRef.current = setTimeout(() => {
      setUrlCopied(false);
    }, 3000);
  };

  const maskedPassword = '•'.repeat(Math.max(password.password?.length || 0, 6));

  return (
    <article className="w-full min-w-0 bg-white border border-gray-300 rounded-lg p-3 flex flex-col gap-2">
      <header className="flex items-center justify-between gap-2">
        <h2 className="font-bold text-gray-900 text-md leading-tight truncate min-w-0 flex-1">
          {password.account}
        </h2>
        <div className="flex items-center gap-2 shrink-0">
          {hasUrl && (
            <button
              type="button"
              className="inline-flex items-center justify-center border border-gray-300 rounded bg-white text-gray-700 hover:bg-gray-50 h-7 w-auto px-2 gap-1 text-xs font-normal"
              onClick={handleCopyUrl}
              title={urlCopied ? 'Copied' : 'Copy link'}
              aria-label={urlCopied ? 'Copied' : 'Copy link'}
            >
              <i
                className={
                  urlCopied
                    ? 'fa-solid fa-check text-green-500'
                    : 'fa-solid fa-link'
                }
              />
              Copy link
            </button>
          )}
          <button
            type="button"
            className="inline-flex items-center justify-center border border-gray-300 rounded bg-white text-gray-700 hover:bg-gray-50 h-7 w-7 text-xs"
            onClick={() => onEdit(password)}
            title="Edit"
            aria-label="Edit"
          >
            <i className="fa-solid fa-pen" />
          </button>
          <button
            type="button"
            className="inline-flex items-center justify-center border border-gray-300 rounded bg-white text-gray-700 hover:bg-gray-50 h-7 w-7 text-xs"
            onClick={() => onDelete(password)}
            title="Delete"
            aria-label="Delete"
          >
            <i className="fa-solid fa-trash" />
          </button>
        </div>
      </header>

      <CopyableField
        value={password.username}
        decorIcon="fa-regular fa-id-card"
      />
      <CopyableField
        value={password.password}
        displayValue={visible ? password.password : maskedPassword}
        decorIcon="fa-solid fa-key"
        actionButtons={[
          {
            icon: visible ? 'fa-regular fa-eye-slash' : 'fa-regular fa-eye',
            onClick: () => setVisible((prev) => !prev),
            title: visible ? 'Hide password' : 'Show password',
          },
        ]}
      />

      <NoteDisplay value={password.note} />
    </article>
  );
};

export default PasswordCard;
